import { useDogxContext } from '@libs/dogx';
import { useNavigate } from 'react-router-dom';
import { routes } from '../routes';
import { ViewmodelNegotiationTypeOption } from '@acordocertobr/reneg-offers-hub';
import { useUserStore } from '@libs/acp/store/user/useUserStore';

export const useRkCheckoutFlowExperiment = () => {
  const { getExperimentVariant } = useDogxContext();
  const experimentVariant = getExperimentVariant('dx-rk-checkout-flow');
  const isAtendeSession = window !== window.parent && useUserStore.getState().tokenOrigin() === 'atende';
  const isRenegkitVariant = isAtendeSession || experimentVariant === 'rk-checkout-flow';

  const NEGOTIATION_TYPE_MAP: Partial<Record<string, ViewmodelNegotiationTypeOption>> = {
    with_abatement: 'WITH_ABATEMENT',
    without_abatement: 'FULL',
    overdued_and_upcoming: 'FULL',
    overdued_only: 'OVERDUE_ONLY',
    with_reenrolment: 'WITH_REENROLLMENT',
    without_reenrolment: 'FULL',
  };

  const navigate = useNavigate();

  const goToCheckout = ({ debt, typeSelected, source }: { debt: any; typeSelected?: string; source: string }) => {
    const creditorSystem = debt?.partner?.identifier;
    const creditorSlug = debt?.partner?.partnerIdentifier;

    const params = new URLSearchParams();

    const paramGetters: Array<[string, (d: any) => any]> = [
      ['systemSlug', (d) => d?.partner?.identifier],
      ['offerId', (d) => d?.id],
      ['negotiationTypeOpt', (d) => d?.typeSelected ?? typeSelected],
      // ['paymentOptId', (d) => d?.paymentOptionId ?? d?.paymentOption?.id], - nunca será passado nesse momento, pré seleção deve ser totalmente controlada pelo teste de pré seleção do time de pagamentos
      ['paymentMethod', (d) => d?.paymentMethod],
      ['withFallback', (d) => d?.withFallback],
    ];

    for (const [key, getter] of paramGetters) {
      const val = getter(debt);
      if (val !== undefined && val !== null && val !== '') params.set(key, String(val));
    }

    const slug = creditorSlug ?? creditorSystem ?? '';
    const newPath = routes.checkoutPaymentPrefs.path.replace(':creditorSlug', String(slug));
    const queryString = params.toString();
    const newPathWithParams = queryString ? `${newPath}?${queryString}` : newPath;

    const legacyPath = `/${creditorSystem}/confirmacao`;
    const usedPath = isRenegkitVariant ? newPathWithParams : legacyPath;

    navigate(usedPath, { state: { source } });
  };

  return {
    isRenegkitVariant,
    goToCheckout,
    NEGOTIATION_TYPE_MAP,
  };
};
